import { bugReportLabelsAPI, bugReportSetLabelsAPI } from '../../api/bugReportLabels';

const types = {
  SET_UI_FLAGS: 'SET_UI_FLAGS',
  SET_LABELS: 'SET_LABELS',
  ADD_LABEL: 'ADD_LABEL',
  UPDATE_LABEL: 'UPDATE_LABEL',
  REMOVE_LABEL: 'REMOVE_LABEL',
};

const state = {
  labels: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDestroying: false,
    isSettingLabels: false,
  },
};

const getters = {
  getAll: $state => $state.labels,
  getUIFlags: $state => $state.uiFlags,
};

const actions = {
  fetchAll: async ({ commit }) => {
    commit(types.SET_UI_FLAGS, { isFetching: true });
    try {
      const { data } = await bugReportLabelsAPI.getAll();
      commit(types.SET_LABELS, data);
    } finally {
      commit(types.SET_UI_FLAGS, { isFetching: false });
    }
  },

  create: async ({ commit }, { name, color }) => {
    commit(types.SET_UI_FLAGS, { isCreating: true });
    try {
      const { data } = await bugReportLabelsAPI.create(name, color);
      commit(types.ADD_LABEL, data);
      return data;
    } finally {
      commit(types.SET_UI_FLAGS, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, name, color }) => {
    commit(types.SET_UI_FLAGS, { isUpdating: true });
    try {
      const { data } = await bugReportLabelsAPI.update(id, name, color);
      commit(types.UPDATE_LABEL, data);
      return data;
    } finally {
      commit(types.SET_UI_FLAGS, { isUpdating: false });
    }
  },

  destroy: async ({ commit }, id) => {
    commit(types.SET_UI_FLAGS, { isDestroying: true });
    try {
      await bugReportLabelsAPI.destroy(id);
      commit(types.REMOVE_LABEL, id);
    } finally {
      commit(types.SET_UI_FLAGS, { isDestroying: false });
    }
  },

  setLabels: async ({ commit }, { bugReportId, labelIds }) => {
    commit(types.SET_UI_FLAGS, { isSettingLabels: true });
    try {
      const { data } = await bugReportSetLabelsAPI.setLabels(bugReportId, labelIds);
      return data;
    } finally {
      commit(types.SET_UI_FLAGS, { isSettingLabels: false });
    }
  },
};

const mutations = {
  [types.SET_UI_FLAGS]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  [types.SET_LABELS]($state, labels) {
    $state.labels = labels;
  },
  [types.ADD_LABEL]($state, label) {
    $state.labels = [...$state.labels, label].sort((a, b) => a.name.localeCompare(b.name));
  },
  [types.UPDATE_LABEL]($state, updated) {
    $state.labels = $state.labels
      .map(l => (l.id === updated.id ? updated : l))
      .sort((a, b) => a.name.localeCompare(b.name));
  },
  [types.REMOVE_LABEL]($state, id) {
    $state.labels = $state.labels.filter(l => l.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
